import { render, staticRenderFns } from "./PrestacaoContasFinal.vue?vue&type=template&id=c1ae08ea&"
import script from "./PrestacaoContasFinal.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContasFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports